var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddToCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6928 7.22222C30.6928 6.63285 30.4618 6.06762 30.0508 5.65087C29.6398 5.23413 29.0824 5 28.5011 5C27.9198 5 27.3624 5.23413 26.9514 5.65087C26.5403 6.06762 26.3094 6.63285 26.3094 7.22222M36.4568 12.44L37.9745 22.44C38.0225 22.7565 38.0025 23.0798 37.9158 23.3877C37.8292 23.6956 37.6779 23.9809 37.4723 24.224C37.2668 24.4672 37.0119 24.6624 36.725 24.7963C36.4381 24.9302 36.1261 24.9997 35.8103 25H21.1919C20.8759 25 20.5636 24.9308 20.2765 24.797C19.9894 24.6632 19.7342 24.468 19.5284 24.2249C19.3226 23.9817 19.1711 23.6963 19.0843 23.3882C18.9975 23.0802 18.9774 22.7567 19.0255 22.44L20.5432 12.44C20.6228 11.9151 20.8852 11.4365 21.2828 11.0908C21.6804 10.7451 22.187 10.5552 22.7107 10.5556H34.2915C34.815 10.5555 35.3213 10.7455 35.7187 11.0911C36.1161 11.4368 36.3772 11.9153 36.4568 12.44Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5H12M8.5 13V20",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToCart);
export default __webpack_public_path__ + "static/media/iconAddToCart.5df2925715e954809570117416be3197.svg";
export { ForwardRef as ReactComponent };